import React from 'react';
import {
  RouterProvider as ReactRouterProvider,
  RouterProviderProps as ReactRouterProviderProps
} from 'react-router-dom';

import { SplashSpinner } from '../SplashSpinner/SplashSpinner';

interface RouterProviderProps extends ReactRouterProviderProps {}

export const RouterProvider = (props: RouterProviderProps) => {
  const { fallbackElement, router, ...rest } = props;
  return <ReactRouterProvider fallbackElement={fallbackElement || <SplashSpinner />} router={router} {...rest} />;
};
